<sdk-conversation-group-nav
  [conversationFilter]="openConversationFilter"
  [darkMode]="true"
  [emptyStateSubtitle]="'This is where you and the hiring team talk with candidates about their application'"
  [groupFn]="groupFn"
  [groupSubtitleFn]="groupSubtitleFn"
  [groupNameFn]="groupNameFn"
  [types]="[ConversationTypes.JobApplication]"
></sdk-conversation-group-nav>
